import { render } from "./Notifications.vue?vue&type=template&id=85f5222a&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.scss?vue&type=style&index=0&id=85f5222a&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./Notifications.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85f5222a"]])

export default __exports__